import React from 'react';
function DiagonallyCollapseOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M16.3032 9.23215H9.23215V16.3032L16.3032 9.23215Z" })));
}
export default DiagonallyCollapseOutlined;
